import React from 'react';
import {
    Breadcrumb as MaestroBreadcrumb,
    useBreakpoint,
    Container,
    Box,
} from '@landr/maestro';
import { Link } from 'react-router-dom';
import { css } from '@landr/styled-system/css';
import { Breadcrumb, BreadcrumbPath } from './types';
import { BreadcrumbListSchema } from './BreadcrumbListSchema';

export const usePageBreadcrumbs = ({
    breadcrumbs,
}: {
    breadcrumbs: Breadcrumb[];
}) => {
    const isMobile = useBreakpoint('md');
    const maxDepth = isMobile ? 2 : 5;

    const breadcrumbPaths: BreadcrumbPath[] = breadcrumbs.map((breadcrumb) => {
        let path = `/${breadcrumb.route}`;

        // add wildcard if it exists
        if (breadcrumb.wildcard) {
            path += `/${breadcrumb.wildcard}`;
        }

        return {
            ...(breadcrumb.isCurrent
                ? { isCurrent: breadcrumb.isCurrent }
                : {}),
            label: breadcrumb.label,
            path: path,
        };
    });

    return { breadcrumbPaths, maxDepth };
};

export const wrapper = css({
    display: 'flex',
    flexGrow: 10,
    alignItems: 'end',
    pt: {
        base: 'lg',
        md: 'xl',
    },
});

export const PageBreadcrumbs = ({
    breadcrumbs,
}: {
    breadcrumbs: Breadcrumb[];
}) => {
    const { breadcrumbPaths, maxDepth } = usePageBreadcrumbs({
        breadcrumbs,
    });

    return (
        <>
            <Box className={wrapper}>
                <Container>
                    <MaestroBreadcrumb maxDepth={maxDepth}>
                        {breadcrumbPaths
                            .filter((breadcrumb) => !!breadcrumb?.label)
                            .map(({ label, path, isCurrent = false }) => (
                                <MaestroBreadcrumb.Item key={path}>
                                    <MaestroBreadcrumb.Link
                                        as={Link}
                                        to={path}
                                        isCurrent={isCurrent}
                                    >
                                        {label}
                                    </MaestroBreadcrumb.Link>
                                </MaestroBreadcrumb.Item>
                            ))}
                    </MaestroBreadcrumb>
                </Container>
            </Box>
            <BreadcrumbListSchema breadcrumbs={breadcrumbPaths} />
        </>
    );
};
